export { default } from "./CurricUnitModalFooter";
